import React from "react";
import { Button } from "components/ui/button";
import { motion } from "framer-motion";

import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const CTABanner = () => {
  const navigate = useNavigate();
  return (
    <section className="py-24 bg-gradient-primary relative overflow-hidden">
      {/* Animated background elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-white/10 rounded-full blur-[120px] animate-float" />
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-white/5 rounded-full blur-[100px]" />

      <div className="container mx-auto px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center max-w-4xl mx-auto"
        >
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.6 }}
            viewport={{ once: true }}
            className="text-4xl lg:text-6xl font-heading font-bold text-white mb-6 leading-tight"
          >
            Ready to transform your Facebook &amp; Instagram engagement?
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.6 }}
            viewport={{ once: true }}
            className="text-xl text-white/90 mb-10 leading-relaxed"
          >
            Join thousands of businesses using Moujib to automate moderation and
            boost engagement
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.6 }}
            viewport={{ once: true }}
          >
            <Button
              onClick={() => navigate("/login")}
              size="lg"
              className="bg-white text-primary hover:bg-white/90 text-lg px-10 py-6 h-auto shadow-2xl hover:shadow-glow-lg transition-all duration-300 group"
            >
              Start Free Trial
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
            <p className="text-white/70 text-sm mt-4">
              No credit card required • 14-day free trial
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTABanner;
